export var phoneReg = /(1\d{10}$)|(7\d{10}$)/;
export var formatPhone = function formatPhone(phone) {
  return phone;
};
export var formatCode = function formatCode(code) {
  return code;
};
export var onNumberInputChange = function onNumberInputChange(e, length, setMethod) {
  var origin = e.target.value;
  var v = origin.replace(/[^0-9]/g, '');
  // const threeReg = /^\d{4}.*/
  // const sevenReg = /^\d{3}\s\d{5}.*/
  // let { selectionEnd } = e.target
  // if (v > 3) {
  //   if ((origin.length === v.length && selectionEnd > 3) || (origin.length > v.length && selectionEnd === 4 && threeReg.test(origin))) {
  //     selectionEnd++
  //   }
  //   if (v > 7) {
  //     if ((origin.length - v.length === 1 && selectionEnd > 8) || (origin.length - v.length === 2 && selectionEnd === 9 && sevenReg.test(origin))) {
  //       selectionEnd++
  //     }
  //   }
  // }
  // if (v.length > length) {
  //   e.preventDefault()
  //   return false
  // }
  // runAtNextFrame(() => {
  //   e.target.setSelectionRange(selectionEnd, selectionEnd)
  // })
  return setMethod(v.slice(0, length));
};